import {
  isOfficeViewerSupported,
  useIsOfficeViewerEnabled,
  OfficeDocViewer,
} from '@/components/common/OfficeDocViewer';
import { XlsxViewer } from './XlsxViewer';

interface ExcelDocViewerProps {
  /** S3 URL for the local XLSX parser (the fallback viewer) */
  url: string;
  fileName: string;
  /** Document ID for the Office Online viewer (omit to force the fallback) */
  documentId?: string;
  height?: string | number;
}

/**
 * Excel document viewer: renders the Microsoft Office Online viewer whenever
 * it can (cleaner than the local parser), silently falling back to the
 * built-in XLSX parser when Office Online isn't available:
 * - the `msft-office-viewer-enabled` feature flag is off,
 * - no `documentId` is provided, or
 * - the file extension isn't supported by Office Online.
 */
export function ExcelDocViewer({
  url,
  fileName,
  documentId,
  height = 450,
}: ExcelDocViewerProps) {
  const officeViewerEnabled = useIsOfficeViewerEnabled();
  const canUseOfficeViewer =
    officeViewerEnabled && !!documentId && isOfficeViewerSupported(fileName);

  if (!canUseOfficeViewer) {
    return <XlsxViewer url={url} fileName={fileName} height={height} />;
  }

  return (
    <OfficeDocViewer
      documentId={documentId}
      height={height}
      className="rounded-md border"
    />
  );
}
